import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { initGtm } from './gtm'

import VueDaumPostcode from 'vue-daum-postcode'

import "@/assets/css/default.css"
import "@/assets/css/quill.snow.css"
import "@/assets/css/common.css"
import "@vueform/toggle/themes/default.css"
import "@/assets/css/style.css"

// GTM 클라이언트 정보는 컨테이너가 첫 태그를 쏘기 전에 올려야 한다.
initGtm()

const app = createApp(App)
app.use(store).use(router).use(VueDaumPostcode)
app.mount('#app')
